<form [formGroup]="formPesquisar" (submit)="OnPesquisar()">
  <breadcrumb [paginas]="breadcrumb" />

  <section class="section-filtro">
    <app-filtro-padrao
      (filtroEmitter)="listeningFiltroEmitter($event)"
      (poloChange)="onPoloChange($event)"
      [template]="2"
      [style]="1"
      [atividadeDE]="true"
      [usePolo]="true"
      [psiInativos]="true"
      [cpfPsicologoSelecionado]="cpfPsicologoSelecionado"
    ></app-filtro-padrao>
  </section>

  <section class="section-saudacao">
    <div class="container">
      <h2 class="titulo-page">Painel de Atividade do Psicólogo</h2>
      <button
        type="button"
        class="btn_adicionar_registro btn_adicionar_jornada_antiga"
        [disabled]="!podeAdicionarJornadaRetroativa"
        title="Adicionar Jornada Retroativa"
        (click)="AbrirAdicionarJornada()"
      >
        <i aria-hidden="true" class="fa fa-plus"></i>
        <span>Adicionar Jornada Retroativa</span>
      </button>
    </div>
  </section>

  <section class="section-busca-filtro-psicologo">
    <div class="container">
      <div class="busca-psicologo">
        <p>Busca Psicólogos</p>

        <div class="conteudo-psicologo">
          <div class="grup_input">
            <label>Psicologo</label>
            <ng-select
              [items]="lstPsicologos"
              bindLabel="nomePsicologoCompleto"
              bindValue="codigoCPF"
              placeholder="Selecione um Psicólogo"
              name="codigoCPF"
              formControlName="codigoCPF"
              class="input-psicologo"
              (change)="popularPsicologo()"
              [ngClass]="{
                'is-invalid': submitted && form.codigoCPF.errors
              }"
            >
            </ng-select>
          </div>
        </div>
      </div>

      <div class="periodo">
        <p><b>Pesquisar por período:</b></p>
        <div class="periodo-input">
          <input type="date" name="dataInicio" formControlName="dataInicio" />
          &nbsp;-&nbsp;
          <input type="date" name="dataFim" formControlName="dataFim" />
        </div>
      </div>
    </div>
  </section>

  <section class="section-grid-consulta-ponto">
    <div class="container">
      <div class="row_registros">
        <h3>Listagem de Visita</h3>

        <div class="conteudo-legenda">
          <div class="legenda-acoes">
            <p>
              <b>Legenda Ações</b>
            </p>
            <div class="conteudo-acoes-legenda">
              <div class="iten-legenda">
                <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
              </div>
              <div
                class="iten-legenda"
                *ngIf="
                  perfisQuePodemAprovar.includes(userLogado?.codigoPerfil!)
                "
              >
                <i class="fa-regular fa-square-check" aria-hidden="true"></i
                > Aprovação
              </div>
              <div
                class="iten-legenda"
                *ngIf="
                  perfisJustificativaHorarioPsicologo.includes(
                    userLogado?.codigoPerfil!
                  )
                "
              >
                <i class="fa-solid fa-clock" aria-hidden="true"></i>
                Justificativa Horário Psicólogo
              </div>
              <!-- <div
                class="iten-legenda"
                *ngIf="
                  perfisJustificativaTempoRegistroAtividade.includes(
                    userLogado?.codigoPerfil!
                  )
                "
              >
                <i class="icon-justificativa-tempo-registro"></i>
                Justificativa Tempo de registro de atividade
              </div> -->
              <div
                class="iten-legenda"
                *ngIf="
                  perfisJustificativaDistancia.includes(
                    userLogado?.codigoPerfil!
                  )
                "
              >
                <i class="fa-solid fa-comment" aria-hidden="true"></i>
                Justificativa Distância
              </div>

              <div
                class="iten-legenda"
                *ngIf="
                  perfisJustificativaHorarioPsicologoFiscal.includes(
                    userLogado?.codigoPerfil!
                  )
                "
              >
                <i class="fa-solid fa-clock" aria-hidden="true"></i> Solicitação
                de ajuste do horário Psicólogo
              </div>

              <div class="iten-legenda">
                <i
                  class="fa-solid fa-edit"
                  aria-hidden="true"
                  *ngIf="
                    perfisEditarAtividade.includes(userLogado?.codigoPerfil!)
                  "
                ></i>
                Edição de atividade
              </div>
              <div class="iten-legenda">
                <i
                  class="fa-solid fa-circle-plus"
                  aria-hidden="true"
                  *ngIf="
                    perfisInserirAtividade.includes(userLogado?.codigoPerfil!)
                  "
                ></i>
                Inserir atividade
              </div>
              <div class="iten-legenda">
                <i
                  class="fa-solid fa-trash"
                  aria-hidden="true"
                  *ngIf="
                    perfisExcluirAtividade.includes(userLogado?.codigoPerfil!)
                  "
                ></i>
                Excluir
              </div>
            </div>
          </div>

          <div class="legenda-aprovacao">
            <p>
              <b>Legenda Aprovação</b>
            </p>
            <div class="conteudo-aprovacao-legenda">
              <div class="iten-legenda status-validado">
                <i class="fa-solid fa-circle"></i> Validado
              </div>
              <div class="iten-legenda status-nao-validado">
                <i class="fa-solid fa-circle"></i> Não Validado
              </div>
              <div class="iten-legenda status-nao-registrado">
                <i class="fa-solid fa-circle-dot"></i> Não Registrado
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-aviso-atividade-jornada />

      <div class="grid-datatable" *ngIf="submitted">
        <!-- #155893 — refreshKey força redraw da coluna Ações após filtro de Escola -->
        <app-tabulator-table
          [rowFormatter]="this.rowFormatter"
          [tableData]="lstPainelAtividadePsicologos"
          [refreshKey]="gridAcoesRefreshKey"
          [columnNames]="colunasGrid"
          [orientacaoPortrait]="false"
          [mostrarFiltro]="false"
          [mostrarImprimir]="false"
          [tableTitle]="'Atividades do Psicólogo'"
          [subTable]="true"
          [subColumnNames]="subGridCols"
        ></app-tabulator-table>
      </div>
    </div>
  </section>
</form>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>

<app-modal *ngIf="showModalJustificativaTempoRegistroAtividade">
  <div class="container-conviva form-registro modal-envolvidos">
    <form [formGroup]="formJustificativaTempoRegistroAtividade">
      <div class="modal-header">
        <div class="titulo-modal">
          <h2>Justificativa Tempo de Registro de Atividade</h2>
        </div>
        <button
          class="btn-fechar-modal"
          (click)="closeModalJustificativaTempoRegistroAtividade()"
        >
          ✖
        </button>
      </div>
      <hr size="20" />
      <div class="descricao-modal-excluir">
        <label for="select-gravidade">Justificativa:</label>
        <textarea
          id="text-justificativaTempoRegistroAtividade"
          name="text-justificativaTempoRegistroAtividade"
          rows="6"
          cols="50"
          formControlName="justificativaTempoRegistroAtividade"
          name="justificativaTempoRegistroAtividade"
          minlength="10"
          maxlength="500"
          (keyup)="OnChangeCountLetters(1)"
          [ngClass]="{
            'is-invalid':
              submitted && formTempo.justificativaTempoRegistroAtividade.errors
          }"
          aria-describedby="descricao-error"
        >
        </textarea>
        <p>Quantidade de caracteres atual: {{ qtdeCaracteresDescricao }}</p>
        <div
          *ngIf="
            submitted && formTempo.justificativaTempoRegistroAtividade.errors
          "
          class="alert"
        >
          <div
            *ngIf="
              formTempo.justificativaTempoRegistroAtividade.errors?.required
            "
          >
            * Descrição da ocorrência é obrigatório.
          </div>
          <div
            *ngIf="
              formTempo.justificativaTempoRegistroAtividade.errors?.minlength
            "
          >
            * É obrigatório no mínimo digitar 10 caracteres.
          </div>
          <div
            *ngIf="
              formTempo.justificativaTempoRegistroAtividade.errors?.maxlength
            "
          >
            * Maximo de caracteres é 500.
          </div>
        </div>
      </div>
      <hr size="20" />
      <div class="container-btns">
        <input
          type="button"
          (click)="closeModalJustificativaTempoRegistroAtividade()"
          class="btn_primary"
          value="OK"
        />
      </div>
    </form>
  </div>
</app-modal>

<app-modal *ngIf="showModalJustificativaDistancia">
  <div class="container-conviva form-registro modal-envolvidos">
    <form [formGroup]="formJustificativaDistancia">
      <div class="modal-header">
        <div class="titulo-modal">
          <h2>Justificativa Distância</h2>
        </div>
        <button
          class="btn-fechar-modal"
          (click)="closeModalJustificativaDistancia()"
        >
          ✖
        </button>
      </div>
      <hr size="20" />
      <div class="descricao-modal-excluir">
        <label for="select-gravidade">Justificativa:</label>
        <textarea
          id="text-JustificativaDistancia"
          name="text-JustificativaDistancia"
          rows="6"
          cols="50"
          formControlName="JustificativaDistancia"
          name="JustificativaDistancia"
          minlength="10"
          maxlength="500"
          (keyup)="OnChangeCountLetters(2)"
          [ngClass]="{
            'is-invalid':
              submitted && formDistancia.JustificativaDistancia.errors
          }"
          aria-describedby="descricao-error"
        >
        </textarea>
      </div>
      <hr size="20" />
      <div class="container-btns">
        <input
          type="button"
          (click)="closeModalJustificativaDistancia()"
          class="btn_primary"
          value="OK"
        />
      </div>
    </form>
  </div>
</app-modal>

<app-modal *ngIf="showModalJustificativaCheckinOutPsicologo">
  <div
    class="container-conviva form-registro modal-envolvidos modal-solicitacao-ajuste-entrada-saida"
  >
    <form [formGroup]="formJustificativaCheckinOut">
      <div class="modal-header">
        <div class="titulo-modal">
          <h2>Solicitação de ajuste de entrada/saída</h2>
        </div>
        <button
          class="btn-fechar-modal"
          (click)="closeModalJustificativaCheckinOutPsicologo()"
        >
          ✖
        </button>
      </div>
      <div>
        <p class="icon-paragraph">
          <img
            src="../../../assets/img/icons/icon-calendario.svg"
            title="Diretoria de Ensino"
            alt=""
          />
          <b>Data:</b>
          {{
            itemJustificativaCheckinOutPsicologo.dataInicio
              | date : "dd/MM/yyyy"
          }}
        </p>
        <p class="icon-paragraph">
          <img
            src="../../../assets/img/icons/icon-nome-escola.svg"
            title="icon Polo e Diretoria de Ensino"
            alt=""
            aria-hidden="true"
          />
          <b>Polo / URE:</b>
          {{ itemJustificativaCheckinOutPsicologo.codigoPolo }} -
          {{ itemJustificativaCheckinOutPsicologo.nomeDiretoria }}
        </p>
        <p class="icon-paragraph">
          <img
            src="../../../assets/img/icons/icon-nome-escola.svg"
            title="Icone Escola"
            alt=""
            aria-hidden="true"
          />
          <b>Escola:</b> {{ itemJustificativaCheckinOutPsicologo.nomeEscola }}
        </p>
      </div>
      <hr size="20" />
      <div class="descricao-modal-excluir">
        <label for="select-gravidade">Tipo de Registro:</label>
        <select
          formControlName="tipoRegistro"
          name="tipoRegistro"
          class="form-control"
          (change)="onChangeTipoRegistro()"
        >
          <option value="1">Entrada</option>
          <option value="2">Saída</option>
          <option value="3">Entrada e Saída</option>
        </select>
      </div>
      <div class="descricao-modal-excluir">
        <label
          *ngIf="formCheckinOut.tipoRegistro.value != 3"
          for="select-gravidade"
          >Justificação da Solicitação:</label
        >
        <label
          *ngIf="formCheckinOut.tipoRegistro.value == 3"
          for="select-gravidade"
          >Justificação da Solicitação Entrada:</label
        >
        <textarea
          id="text-JustificativaCheckin"
          name="text-JustificativaCheckin"
          rows="6"
          cols="50"
          formControlName="JustificativaCheckin"
          name="JustificativaCheckin"
          minlength="10"
          maxlength="500"
          (keyup)="OnChangeCountLetters(3)"
          [ngClass]="{
            'is-invalid':
              submitted && formCheckinOut.JustificativaCheckin.errors
          }"
          aria-describedby="descricao-error"
        ></textarea>
        <p>Quantidade de caracteres atual: {{ qtdeCaracteresDescricao }}</p>
        <div
          *ngIf="submitted && formCheckinOut.JustificativaCheckin.errors"
          class="alert"
        >
          <div *ngIf="formCheckinOut.JustificativaCheckin.errors?.required">
            * Descrição da ocorrência é obrigatório.
          </div>
          <div *ngIf="formCheckinOut.JustificativaCheckin.errors?.minlength">
            * É obrigatório no mínimo digitar 10 caracteres.
          </div>
          <div *ngIf="formCheckinOut.JustificativaCheckin.errors?.maxlength">
            * Maximo de caracteres é 500.
          </div>
        </div>
      </div>
      <div
        class="descricao-modal-excluir"
        *ngIf="formCheckinOut.tipoRegistro.value == 3"
      >
        <label for="select-gravidade">Justificação da Solicitação Saída:</label>
        <textarea
          id="text-JustificativaCheckout"
          name="text-JustificativaCheckout"
          rows="6"
          cols="50"
          formControlName="JustificativaCheckout"
          name="JustificativaCheckout"
          minlength="10"
          maxlength="500"
          (keyup)="OnChangeCountLetters(5)"
          [ngClass]="{
            'is-invalid':
              submitted && formCheckinOut.JustificativaCheckout.errors
          }"
          aria-describedby="descricao-error"
        ></textarea>
        <p>Quantidade de caracteres atual: {{ qtdeCaracteresDescricaoOut }}</p>
        <div
          *ngIf="submitted && formCheckinOut.JustificativaCheckout.errors"
          class="alert"
        >
          <div *ngIf="formCheckinOut.JustificativaCheckout.errors?.required">
            * Descrição da ocorrência é obrigatório.
          </div>
          <div *ngIf="formCheckinOut.JustificativaCheckout.errors?.minlength">
            * É obrigatório no mínimo digitar 10 caracteres.
          </div>
          <div *ngIf="formCheckinOut.JustificativaCheckout.errors?.maxlength">
            * Maximo de caracteres é 500.
          </div>
        </div>
      </div>
      <div class="descricao-modal-excluir">
        <label
          *ngIf="formCheckinOut.tipoRegistro.value != 3"
          for="select-gravidade"
          >Hora:
        </label>
        <label
          *ngIf="formCheckinOut.tipoRegistro.value == 3"
          for="select-gravidade"
          >Hora Entrada:</label
        >
        <input
          type="time"
          formControlName="timeCheckinOutEntrada"
          name="timeCheckinOutEntrada"
          class="form-control"
        />
        <div *ngIf="formCheckinOut.tipoRegistro.value == 3">
          <label for="select-gravidade">Hora Saída:</label>
          <input
            type="time"
            formControlName="timeCheckinOutSaida"
            name="timeCheckinOutSaida"
            class="form-control"
          />
        </div>
      </div>
      <hr size="20" />
      <div class="container-btns">
        <input
          type="button"
          (click)="closeModalJustificativaCheckinOutPsicologo()"
          class="btn_outline"
          value="Cancelar"
        />
        <input
          type="button"
          (click)="CadastrarJustificativaCheckinOutPsicologo()"
          class="btn_primary"
          value="Enviar para Aprovação"
        />
      </div>
    </form>
  </div>
</app-modal>

<app-modal *ngIf="showModalAdicionarJornada">
  <div class="container-conviva form-registro modal-adicionar-jornada" [ngClass]="{'modal-expandido-deslocamento': showSectionDeslocamento}">
    <form [formGroup]="formAdicionarJornada">
      <div class="modal-header">
        <div class="titulo-modal">
          <h2>Adicionar Jornada Retroativa</h2>
        </div>
        <button class="btn-fechar-modal" (click)="closeModalAdicionarJornada()">
          ✖
        </button>
      </div>

      <div class="descricao-modal-excluir">
        <div class="conteudo-select">
          <label>Data e Hora do Check-In: </label>
          <p *ngIf="restringeDataRetroativaJornada" class="aviso-jornada-retroativa">{{ avisoLimiteJornadaRetroativa }}</p>
          <input
            type="datetime-local"
            name="dataCheckIn"
            class="input-date"
            formControlName="dataCheckIn"
            aria-label="Data e Hora do Check-In"
            [disabled]="showModalJornadaAtividades"
            (change)="onChangeDataCheckIn()"
            (blur)="onBlurDataCheckIn()"
            [attr.min]="dataMinimaCheckInJornada"
            [attr.max]="dataMaximaCheckInJornada"
          />
          <div *ngIf="(submitted || formJornada.dataCheckIn.touched) && formJornada && formJornada.dataCheckIn && formJornada.dataCheckIn.errors" class="alert">
            <div *ngIf="formJornada.dataCheckIn.errors.dataFutura">{{ formJornada.dataCheckIn.errors.dataFutura }}</div>
            <div *ngIf="formJornada.dataCheckIn.errors.dataRetroativaLimite">{{ formJornada.dataCheckIn.errors.dataRetroativaLimite }}</div>
          </div>
        </div>

        <div class="conteudo-select">
          <label>Data e Hora do Check-Out: </label>
          <input
            type="time"
            id="dataCheckOut"
            name="dataCheckOut"
            class="input-time"
            formControlName="dataCheckOut"
            aria-label="Data e Hora do Check-Out"
            [disabled]="showModalJornadaAtividades"
          />
        </div>

        <div class="grupo-filter-modal">
          <label>URE</label>
          <ng-select
            [items]="diretoriasModal"
            bindLabel="nomeDiretoria"
            bindValue="codigoDiretoria"
            placeholder="Selecione uma URE"
            formControlName="codigoDiretoriaModal"
            name="codigoDiretoriaModal"
            [searchFn]="searchUreModalFn"
            (change)="getEscolasModal()"
            [disabled]="showModalJornadaAtividades"
          >
          </ng-select>

          <div *ngIf="formJornada.codigoDiretoriaModal.errors" class="alert">
            <div *ngIf="formJornada.codigoDiretoriaModal.errors.required">
              * URE é obrigatório
            </div>
          </div>

          <div class="grupo-filter-ano">
            <p><b>Atividade na URE</b></p>
            <label>
              <input
                type="checkbox"
                [checked]="this.atividadeDiretoria"
                class="checkbox"
                (click)="OnChangeApenasDiretoria()"
                [disabled]="showModalJornadaAtividades"
              /><i></i>
            </label>
          </div>
        </div>

        <div class="grupo-filter-modal">
          <label>Escola</label>
          <ng-select
            [items]="escolasModal"
            bindLabel="nomeEscola"
            bindValue="codigoEscola"
            placeholder="Selecione uma Escola"
            formControlName="codigoEscolaModal"
            name="codigoEscolaModal"
            [searchFn]="searchEscolaModalFn"
            (change)="onChangeEscolaModalJornada()"
            [disabled]="showModalJornadaAtividades"
          >
          </ng-select>
          <div *ngIf="formJornada.codigoEscolaModal.errors" class="alert">
            <div *ngIf="formJornada.codigoEscolaModal.errors.required">
              * Escola é obrigatório
            </div>
          </div>
        </div>

        <div class="grupo-filter-modal">
          <label for="text-JustificativaSolicitacao">Justificação da Solicitação:</label>
          <textarea
            id="text-JustificativaSolicitacao"
            name="text-JustificativaSolicitacao"
            rows="6"
            cols="50"
            formControlName="JustificativaSolicitacao"
            name="JustificativaSolicitacao"
            minlength="10"
            maxlength="500"
            (keyup)="OnChangeCountLetters(4)"
            [ngClass]="{
              'is-invalid':
                submitted && formJornada.JustificativaSolicitacao.errors
            }"
            aria-describedby="descricao-error"
            [disabled]="showModalJornadaAtividades"
          ></textarea>
          <p>Quantidade de caracteres atual: {{ qtdeCaracteresDescricao }}</p>
          <div
            *ngIf="submitted && formJornada.JustificativaSolicitacao.errors"
            class="alert"
          >
            <div *ngIf="formJornada.JustificativaSolicitacao.errors?.required">
              * Descrição da ocorrência é obrigatório.
            </div>
            <div *ngIf="formJornada.JustificativaSolicitacao.errors?.minlength">
              * É obrigatório no mínimo digitar 10 caracteres.
            </div>
            <div *ngIf="formJornada.JustificativaSolicitacao.errors?.maxlength">
              * Maximo de caracteres é 500.
            </div>
          </div>
        </div>

        @if(this.showBotonDeslocamento){
          <div class="grupo-filter-modal">
            <input
              type="button"
              (click)="toggleDeslocamento()"
              [class]="showSectionDeslocamento ? 'btn_outline' : 'btn_primary'"
              [value]="showSectionDeslocamento ? 'Sem deslocamento' : 'Deslocamento'"
            />
          </div>
          }

      </div>

      @if(showSectionDeslocamento){
        <div class="deslocamento">

          <div class="box-duas-colum">

            <div class="grupo-filter">
              <p><b>URE Origem</b></p>
              <ng-select
                [items]="diretoriasOrigem"
                bindLabel="nomeDiretoria"
                bindValue="codigoDiretoria"
                placeholder="Selecione uma URE"
                formControlName="codigoDiretoriaOrigem"
                name="codigoDiretoriaOrigem"
                (change)="trocaDiretoriaOrigem()"
                [ngClass]="{ 'is-invalid': submitted && formJornada.codigoDiretoriaOrigem.errors }"
              >
              </ng-select>
              <div *ngIf="submitted && formJornada.codigoDiretoriaOrigem.errors" class="alert">
                <div *ngIf="formJornada.codigoDiretoriaOrigem.errors.required">
                  * URE Origem é obrigatório
                </div>
              </div>

              <div class="grupo-filter-ano">
                <p><b>Atividade na URE</b></p>
                <label>
                  <input type="checkbox" [checked]="this.atividadeDiretoriaOrigem" class="checkbox" (click)="OnChangeApenasDiretoriaOrigem()"/><i></i>
                </label>
              </div>
            </div>

            <div class="grupo-filter">
              <p><b>Escola Origem</b></p>
              <ng-select
                [items]="escolasOrigem"
                bindLabel="nomeEscola"
                bindValue="codigoEscola"
                placeholder="Selecione uma Escola"
                formControlName="codigoEscolaOrigem"
                name="codigoEscolaOrigem"
                [searchFn]="searchEscolaModalFn"
                (change)="removerRota()"
                [ngClass]="{ 'is-invalid': submitted && formJornada.codigoEscolaOrigem.errors }"
              >
              </ng-select>
              <div *ngIf="submitted && formJornada.codigoEscolaOrigem.errors" class="alert">
                <div *ngIf="formJornada.codigoEscolaOrigem.errors.required">
                  * Escola é obrigatório
                </div>
              </div>
            </div>

            <div class="grupo-filter">
              <p><b>Transporte</b></p>
              <ng-select
                [items]="lstTipoTransporte"
                bindLabel="name"
                bindValue="id"
                placeholder="Selecione uma Forma de Transporte"
                formControlName="codigoTipoTransporte"
                name="codigoTipoTransporte"
                (change)="removerRota()"
                [ngClass]="{ 'is-invalid': submitted && formJornada.codigoTipoTransporte.errors }"
              >
              </ng-select>
              <div *ngIf="submitted && formJornada.codigoTipoTransporte.errors" class="alert">
                <div *ngIf="formJornada.codigoTipoTransporte.errors.required">
                  * Tipo de Transporte é obrigatório
                </div>
              </div>
            </div>

            <div class="grupo-filter">
              <p><b>Horário Saída: (hh:mm)</b></p>
              <input type="time" formControlName="horarioSaida" (blur)="trocaHoraSaida()"/>
              <div *ngIf="submitted && formJornada.horarioSaida.errors" class="alert">
                <div *ngIf="formJornada.horarioSaida.errors.required">
                  *Horário de Saída é obrigatório
                </div>
              </div>
            </div>

          </div>
          <div class="box-duas-colum">

            <div class="grupo-filter">
              <p><b>Tempo de Deslocamento:</b></p>
              <input type="time" formControlName="tempoDeslocamento" />

              <div *ngIf="submitted && formJornada.tempoDeslocamento.errors" class="alert">
                <div *ngIf="formJornada.tempoDeslocamento.errors.required">
                  *Tempo de Deslocamento é obrigatório
                </div>
              </div>
            </div>

            <div class="grupo-filter">
              <p><b>Horário Chegada: (hh:mm)</b></p>
              <input type="time" formControlName="horarioChegada" />
              <div *ngIf="submitted && formJornada.horarioChegada.errors" class="alert">
                <div *ngIf="formJornada.horarioChegada.errors.required">
                  *Horário Chegada é obrigatório
                </div>
              </div>
            </div>

            <div class="grupo-filter">
              <p><b>Quilômetro Percorrido: (KM)</b></p>
              <input type="number" formControlName="kmPercorrido" />
              <div *ngIf="submitted && formJornada.kmPercorrido.errors" class="alert">
                <div *ngIf="formJornada.kmPercorrido.errors.required">
                  *Quilômetro Percorrido é obrigatório
                </div>
              </div>
            </div>
          </div>

        <!-- Gerar Rota -->
        <div class="container-btns-visitas">
          <input type="button" class="btn_primary" value="Gerar Deslocamento" (click)="gerarRota()"/>
        </div>

        <!-- Mapa -->
        <div id="map" style="height: 400px; display: none;"></div>

        </div>

      }

      <hr size="20" />

      @if(!showModalJornadaAtividades){
      <div class="container-btns">
        <input
          type="button"
          (click)="closeModalAdicionarJornada()"
          class="btn_outline"
          value="Cancelar"
          [disabled]="showModalJornadaAtividades"
        />
        <input
          type="button"
          (click)="RevisarJornada()"
          class="btn_primary"
          value="Inserir Jornada Retroativa"
          [disabled]="showModalJornadaAtividades"
        />
      </div>
      } @else{
      <p><b>Deseja inserir uma nova atividade na jornada retroativa?</b></p>

      <div class="container-btns adicionar-atividade-jornada-antiga">
        <input
          type="button"
          (click)="redirectToAddAtividade()"
          class="btn_primary"
          value="Adicionar Atividade"
          [disabled]="userLogado?.codigoPerfil == 1632"
        />
        <input
          type="button"
          (click)="closeModalAdicionarJornada()"
          class="btn_outline"
          value="Fechar"
        />
      </div>
      }
    </form>
  </div>
</app-modal>

<app-modal class="modal-overlay" *ngIf="showModalAprovacao">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Enviar Atividades para aprovação?</h2>
      </div>
      <button class="btn-fechar-modal" (click)="toggleModalAprovacao()">
        ✖
      </button>
    </div>
    <br />
    <div class="modal-footer">
      <button class="btn_segundario" (click)="toggleModalAprovacao()">
        Não
      </button>
      <button class="btn_primeiro" (click)="EnviarAtividades()">Sim</button>
    </div>
  </div>
</app-modal>

<app-modal class="modal-overlay" *ngIf="showModalExcluirAtividade">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Deseja excluir o Registro da Atividade?</h2>
      </div>
      <button class="btn-fechar-modal" (click)="toggleModalExcluirAtividade()">
        ✖
      </button>
    </div>
    <br />
    <div class="modal-footer">
      <button class="btn_segundario" (click)="toggleModalExcluirAtividade()">
        Não
      </button>
      <button class="btn_primeiro" (click)="OnExcluirAtividade()">Sim</button>
    </div>
  </div>
</app-modal>

<app-modal class="modal-overlay" *ngIf="showModalExcluirJornada">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Deseja excluir o Registro da Jornada?</h2>
      </div>
      <button class="btn-fechar-modal" (click)="toggleModalExcluirJornada()">
        ✖
      </button>
    </div>
    <br />
    <div class="modal-footer">
      <button class="btn_segundario" (click)="toggleModalExcluirJornada()">
        Não
      </button>
      <button class="btn_primeiro" (click)="OnExcluirJornada()">Sim</button>
    </div>
  </div>
</app-modal>

<app-modal *ngIf="showModalDeslocamento">
  <div class="container-conviva form-registro modal-envolvidos modal-visita-psicologo">
    <div class="header-modal-filtro">
      <h1 class="titulo-page">Deseja fazer um deslocamento ?</h1>
      <a class="btn-fechar-modal" (click)="FecharModalDeslocamento()">fechar</a>
    </div>

    <div class="time-line conteudo-registro modal-conteudo-busca-aluno">
      <div class="container-btns">
        <input type="button" (click)="FecharModalDeslocamento()" class="btn_outline" value="Não" />
        <input type="submit" class="btn_primary" (click)="SectionDeslocamento()" value="Sim" />
      </div>
    </div>
  </div>
</app-modal>
